import React, { useEffect, useState } from "react";

import { v4 as uuidv4 } from "uuid";
import { useSelector } from "react-redux";
import {
  Drawer,
  FormFieldSet,
  Button,
  useFormHandler,
  HeaderStyle,
  showToast,
  Backdrop,
  LogoLoader,
} from "../../../../../../components";
import {
  updateApplicant,
  addApplicant,
  getApplicant,
} from "../../../../../../redux/slices/recruitmentSourcing/SourcingApi";
import { useNavigate } from "react-router-dom";
import { trackEvent } from "../../../../../../utils/mixpanelService";
import { isValidPhoneNumber } from "libphonenumber-js";

const AddApplicantModal = ({
  isOpen,
  onClose,
  edit = false,
  applicantId,
  onSuccess,
  parsedData,
  preselectedResume,
  source,
}) => {
  const [loading, setLoading] = useState(false);
  const [validationRules, setValidationRules] = useState({});
  const { user } = useSelector((state) => state.auth);
  const navigate = useNavigate();
  const initialFormData = {
    firstName: "",
    middleName: "",
    lastName: "",
    gender: "",
    primaryEmailAddress: "",
    secondaryEmailAddress: "",
    // primaryMobileNumber: "",
    primaryMobileNumber: { code: "", number: "" },
    homeMobileNumber: { code: "", number: "" },
    // homeMobileNumber: "",
    personalState: "",
    personalCity: "",
    zipCode: "",
    uploadedResume: {
      id: uuidv4(),
      attachmentName: "",
      attachmentComments: "",
      chooseFiles: [],
    },
    years: "",
    months: "",
    jobTitle: "",
    sourceOfresume: "",
    minExperience: "",
    availability: "",
    skills: "",
    workAuthorization: "",
    readyToRelocate: "yes",
    schoolName: "",
    degree: "",
    yearCompleted: "",
    majorStudy: "",
    minorStudy: "",
    gpa: "",
    country: "",
    educationState: "",
    educationCity: "",
    minExperienceMin: "",
    minExperienceMax: "",
    minExperienceRateType: "",
    minExperienceJobType: "",
  };
  const { formData, errors, handleChange, validateAllFields, setFormData } =
    useFormHandler(initialFormData, validationRules);
  // const handleSubmit = () => {
  //   const isValid = validateAllFields();
  // };
  const handleSubmit = async () => {
    const isValid = validateAllFields();
    if (!isValid) {
      showToast("Enter all required fields!", "error", 2000);
      return;
    }
    const requiredFields = [
      { key: "firstName", label: "First Name" },
      { key: "lastName", label: "Last Name" },
      { key: "jobTitle", label: "Job Title" },
      { key: "primaryEmailAddress", label: "Primary Email Address" },
      { key: "primaryMobileNumber", label: "Primary Mobile Number" },
    ];

    for (const field of requiredFields) {
      const value = formData[field.key];
      if (
        !value ||
        (typeof value === "object" && Object.keys(value).length === 0) ||
        (typeof value === "string" && value.trim() === "")
      ) {
        showToast(`${field.label} is required!`, "error");
        return;
      }
    }
    if (!formData.primaryMobileNumber?.number) {
      showToast("Primary Mobile Number is required!", "error");
      return;
    }

    const formatedPrimaryMobileNumber =  `${formData?.primaryMobileNumber?.code}${formData?.primaryMobileNumber?.number}`;
    const formatedHomeMobileNumber = `${formData?.homeMobileNumber?.code}${formData?.homeMobileNumber?.number}`;
    //console.log(formatedPrimaryMobileNumber,formatedHomeMobileNumber)
    if (!isValidPhoneNumber(formatedPrimaryMobileNumber)) {
      showToast("Enter a valid primary mobile number", "error");
      return;
    }
    if (formData?.homeMobileNumber?.number && !isValidPhoneNumber(formatedHomeMobileNumber)) {
      showToast("Enter a valid home mobile number", "error");
      return;
    }

    if (formData.years && !/^\d+$/.test(formData?.years)) {
      showToast("Years must contain only numbers", "error");
      return;
    }
     if (formData.months && (!/^\d+$/.test(formData?.months) || Number(formData?.months) < 0 || Number(formData?.months) > 12)) {
      showToast("Months must contain only numbers and between 0-12", "error");
      return;
    }

    if (!edit && !formData.uploadedResume) {
      showToast("Please upload a resume file!", "error");
      return;
    }
    try {
      setLoading(true);
      const payload = {
        firstName: formData.firstName,
        middleName: formData.middleName,
        lastName: formData.lastName,
        addedBy: user?.data?.uiid,
        jobTitle: formData.jobTitle,
        // source: typeof formData.sourceOfResume === "object"
        //   ? Number(formData.sourceOfResume.value)
        //   : Number(formData.sourceOfResume),
        ...(formData?.sourceOfResume !== undefined &&
          formData?.sourceOfResume !== null && {
            source:
              typeof formData?.sourceOfResume === "object"
                ? Number(formData?.sourceOfResume?.value)
                : Number(formData?.sourceOfResume),
          }),
        // gender: formData.gender,
        gender:
          typeof formData.gender === "object"
            ? Number(formData.gender.value)
            : Number(formData.gender),

        // workAuth: formData.workAuthorization,
        workAuth:
          typeof formData.workAuthorization === "object"
            ? formData.workAuthorization.value
            : formData.workAuthorization,
        available: formData.availability,
        relocation: {
          willingness: formData.readyToRelocate,
        },
        mobile: {
          primary: {
            code: formData.primaryMobileNumber?.code,
            number: formData.primaryMobileNumber?.number,
          },
          ...(formData.homeMobileNumber?.number
            ? {
                secondary: {
                  code: formData.homeMobileNumber?.code,
                  number: formData.homeMobileNumber.number,
                },
              }
            : {}),
        },
        email: {
          primary: {
            email: formData.primaryEmailAddress,
          },
          ...(formData.secondaryEmailAddress?.trim() && {
            secondary: {
              email: formData.secondaryEmailAddress.trim(),
            },
          }),
        },
        exp: {
          year: Number(formData.years),
          mon: Number(formData.months),
        },
        // skills: formData.skills
        //   ? formData.skills.split(",").map((skill) => ({ name: skill.trim() }))
        //   : [],
        // skills: Array.isArray(formData.skills)
        //   ? formData.skills.map(skill => ({ name: skill }))
        //   : typeof formData.skills === "string"
        //     ? formData.skills
        //       .split(",")
        //       .map(skill => ({ name: skill.trim() }))
        //     : [],
        ...(formData.skills && {
          skills: Array.isArray(formData.skills)
            ? formData.skills.filter(Boolean).map((skill) => ({ name: skill }))
            : formData.skills
                .split(",")
                .map((skill) => skill.trim())
                .filter(Boolean)
                .map((skill) => ({ name: skill })),
        }),
        educationDetails: [
          {
            degree: formData.degree,
            institute: formData.schoolName,
            major: formData.majorStudy,
            minor: formData.minorStudy,
            gpa: Number(formData.gpa),
            endDate: formData.yearCompleted
              ? new Date(formData.yearCompleted).toISOString()
              : null,
            location: {
              country: formData.country?.value || null,
              state: formData.educationState?.value || null,
              city: formData.educationCity?.value || null,
            },
          },
        ],
        location: {
          // country: {
          //   name: "US"
          // },
          // state: {
          //   name: formData.personalState?.value ||
          //   null,
          // },
          state: formData.personalState?.value || null,
          city: formData.personalCity?.value || null,
          zipCode: Number(formData.zipCode),
        },
        salaryInfo: {
          expect: {
            currency: formData.minExperience,
            amount: {
              min: formData.minExperienceMin,
              max: formData.minExperienceMax,
            },
            // amount: Number(formData.payRateAmount),
            freqType: formData.minExperienceRateType?.toLowerCase(),
            // employmentType: Number(formData.minExperienceJobType),
            ...(formData.minExperienceJobType && {
              employmentType: Number(formData.minExperienceJobType),
            }),
          },
        },
      };
      // console.log("payload",payload)
      const data = new FormData();
      // console.log("📁 formData.uploadedResume:", formData.uploadedResume);

      // let resumeFile = null;

      // if (formData.uploadedResume instanceof File) {
      //   resumeFile = formData.uploadedResume;
      // } else if (Array.isArray(formData.uploadedResume)) {
      //   resumeFile = formData.uploadedResume[0];
      // } else if (formData.uploadedResume?.chooseFiles) {
      //   resumeFile = Array.isArray(formData.uploadedResume.chooseFiles)
      //     ? formData.uploadedResume.chooseFiles[0]
      //     : formData.uploadedResume.chooseFiles;
      // }

      // // if (!resumeFile) {
      // //   showToast("Please upload a resume file!", "error");
      // //   return;
      // // }
      // const allowedTypes = [
      //   "application/pdf",
      //   "application/msword",
      //   "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      // ];
      // const allowedExtensions = [".pdf", ".doc", ".docx"];

      // const fileName = resumeFile.name?.toLowerCase() || "";
      // const fileType = resumeFile.type?.toLowerCase() || "";

      // const isAllowedType =
      //   allowedTypes.includes(fileType) ||
      //   allowedExtensions.some((ext) => fileName.endsWith(ext));

      // if (!isAllowedType) {
      //   showToast("Only PDF, DOC, or DOCX files are allowed!", "error");
      //   return;
      // }
      //   data.append("doc", resumeFile);
      //   data.append("coll", "Candidate");
      //   data.append("postActions", JSON.stringify(["addDoc"]));
      data.append("coll", "Candidate");

      let resumeFile = null;

      if (formData.uploadedResume instanceof File) {
        resumeFile = formData.uploadedResume;
      } else if (Array.isArray(formData.uploadedResume)) {
        resumeFile = formData.uploadedResume[0];
      } else if (formData.uploadedResume?.chooseFiles?.length > 0) {
        resumeFile = formData.uploadedResume.chooseFiles[0];
      }

      // Only validate & append file if present
      if (resumeFile) {
        const allowedTypes = [
          "application/pdf",
          "application/msword",
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        ];
        const allowedExtensions = [".pdf", ".doc", ".docx"];
        const fileName = resumeFile.name?.toLowerCase() || "";
        const fileType = resumeFile.type?.toLowerCase() || "";
        const isAllowedType =
          allowedTypes.includes(fileType) ||
          allowedExtensions.some((ext) => fileName.endsWith(ext));

        if (!isAllowedType) {
          showToast("Only PDF, DOC, or DOCX files are allowed!", "error");
          return;
        }

        data.append("doc", resumeFile);
        data.append("postActions", JSON.stringify(["addDoc"]));
      } else if (!edit) {
        showToast("Please upload a resume file!", "error");
        return;
      }

      if (edit) {
        data.append(
          "payload",
          JSON.stringify([
            {
              type: "SET",
              value: payload,
            },
          ]),
        );

        const params = {
          coll: "Candidate",
          uiid: applicantId,
          data,
        };

        const res = await updateApplicant(params);

        if (res?.data) {
          showToast("Applicant updated successfully", "success");
          handleClose();
          if (source == "bdm-alljobs" || source == "bdm-alljobs-edit") {
            navigate("/ats/jobs");
          } else if (source == "draftJobs" || source == "draftJobs-edit") {
            navigate("/ats/jobs");
            //navigate("/ats/jobs/jobs_draftjobs");
          } else if (
            source == "recruit-alljobs" ||
            source == "recruit-alljobs-edit"
          ) {
            navigate("/ats/recruitment/jobs");
          } else if (
            source == "recruit-myjobs" ||
            source == "recruit-myjobs-edit"
          ) {
            navigate("/ats/recruitment/jobs");
            // navigate("/ats/recruitment/recruitment_jobs/my_jobs");
          } else {
          }
          if (onSuccess) onSuccess();
        } else {
          showToast("Error updating candidate", "error");
        }
      } else {
        // ADD
        data.append("payload", JSON.stringify(payload));

        const res = await addApplicant(data);

        if (res?.data) {
          showToast("Applicant added successfully", "success");
          handleClose();
          if (source == "bdm-alljobs" || source == "bdm-alljobs-edit") {
            navigate("/ats/jobs");
          } else if (source == "draftJobs" || source == "draftJobs-edit") {
            navigate("/ats/jobs");
            //navigate("/ats/jobs/jobs_draftjobs");
          } else if (
            source == "recruit-alljobs" ||
            source == "recruit-alljobs-edit"
          ) {
            navigate("/ats/recruitment/jobs");
          } else if (
            source == "recruit-myjobs" ||
            source == "recruit-myjobs-edit"
          ) {
            navigate("/ats/recruitment/jobs");
            // navigate("/ats/recruitment/recruitment_jobs/my_jobs");
          } else {
          }
          // trackEvent({eventName:"Candidate_Created",props:{candidateName:formData?.firstName}})
          if (onSuccess) onSuccess();
        } else {
          showToast(
            res?.error?.errorResponse?.errmsg ||
              res?.error ||
              "Error adding candidate",
            "error",
          );
          // showToast(res?.error, "error");
        }
      }
    } catch (error) {
      if (error?.response?.data?.error?.includes("Write conflict")) {
        await new Promise((r) => setTimeout(r, 300));
        await addApplicant(formData);
      }
      console.error("Error adding applicant:", error);
      showToast("Failed to add applicant. Please try again.", "error");
    } finally {
      setLoading(false);
    }
  };
  const genderOptions = [
    { label: "MALE", value: 1 },
    { label: "FEMALE", value: 2 },
    { label: "WISH NOT TO SPECIFY", value: 3 },
    { label: "OTHER", value: 4 },
  ];
  const workAuthOptions = [
    { label: "B1", value: "B1" },
    { label: "Bangladesh Authorized", value: "Bangladesh Authorized" },
    { label: "Brazil Authorized", value: "Brazil Authorized" },
    {
      label: "Can work for any employer",
      value: "Can work for any employer",
    },
    { label: "Canada Authorized", value: "Canada Authorized" },
    { label: "Canadian Citizen", value: "Canadian Citizen" },
    { label: "Canadian Citizenship", value: "Canadian Citizenship" },
    { label: "China Authorized", value: "China Authorized" },
    { label: "Citizen", value: "Citizen" },
    { label: "Colombia Authorized", value: "Colombia Authorized" },
    { label: "Current Employer Only", value: "Current Employer Only" },
    {
      label: "Employment Auth Document",
      value: "Employment Auth Document",
    },
    {
      label: "Employment Auth. Document",
      value: "Employment Auth. Document",
    },
    {
      label: "Employment Authorization Document",
      value: "Employment Authorization Document",
    },
    { label: "EU Eligible", value: "EU Eligible" },
    { label: "GC", value: "GC" },
    { label: "GC-EAD", value: "GC-EAD" },
    { label: "Germany Authorized", value: "Germany Authorized" },
    { label: "Green Card", value: "Green Card" },
    { label: "Green Card Holder", value: "Green Card Holder" },
    { label: "H1-B", value: "H1-B" },
    { label: "H4 EAD", value: "H4 EAD" },
    { label: "Have H1", value: "Have H1" },
    { label: "Have H1 Visa", value: "Have H1 Visa" },
    { label: "India Authorized", value: "India Authorized" },
    { label: "Ireland Authorized", value: "Ireland Authorized" },
    { label: "Italy Authorized", value: "Italy Authorized" },
    { label: "Kuwait Authorized", value: "Kuwait Authorized" },
    { label: "L1-A", value: "L1-A" },
    { label: "L1-B", value: "L1-B" },
    { label: "L2-EAD", value: "L2-EAD" },
    { label: "Luxembourg Authorized", value: "Luxembourg Authorized" },
    { label: "Macedonia Authorized", value: "Macedonia Authorized" },
    { label: "Mexico Authorized", value: "Mexico Authorized" },
    { label: "Need H1", value: "Need H1" },
    { label: "Need H1 Visa", value: "Need H1 Visa" },
    { label: "Need H1 Visa Sponsor", value: "Need H1 Visa Sponsor" },
    { label: "Not specified", value: "Not specified" },
    { label: "OPT-EAD", value: "OPT-EAD" },
    { label: "Pakistan Authorized", value: "Pakistan Authorized" },
    { label: "Poland Authorized", value: "Poland Authorized" },
    {
      label: "Russian Federation Authorized",
      value: "Russian Federation Authorized",
    },
    {
      label: "South Africa Authorized",
      value: "South Africa Authorized",
    },
    { label: "Sponsorship Required", value: "Sponsorship Required" },
    { label: "TN Permit Holder", value: "TN Permit Holder" },
    { label: "TN Visa", value: "TN Visa" },
    { label: "Turkey Authorized", value: "Turkey Authorized" },
    { label: "Ukraine Authorized", value: "Ukraine Authorized" },
    {
      label: "United Arab Emirates Authorized",
      value: "United Arab Emirates Authorized",
    },
    {
      label: "United Kingdom Authorized",
      value: "United Kingdom Authorized",
    },
    { label: "US Authorized", value: "US Authorized" },
    { label: "US Citizen", value: "US Citizen" },
    { label: "US Citizenship", value: "US Citizenship" },
    { label: "CTCT", value: "CTCT" },
    { label: "CTEM", value: "CTEM" },
    { label: "EAEA", value: "EAEA" },
  ];
  const sourceOptions = [
    { label: "Internal", value: 1 },
    { label: "Career builder", value: 2 },
    { label: "Monster", value: 3 },
    { label: "Career portal", value: 4 },
    { label: "Careerjet", value: 5 },
    { label: "Dice", value: 6 },
    { label: "Glassdoor", value: 7 },
    { label: "Indeed", value: 8 },
    { label: "Linkedin", value: 9 },
    { label: "Naukari", value: 10 },
    { label: "Neuvoo", value: 11 },
    { label: "Post job free", value: 12 },
    { label: "Snaprecruit", value: 13 },
    { label: "Stack overflow", value: 14 },
    { label: "Ziprecruiter", value: 15 },
    { label: "Employee referral", value: 16 },
    { label: "Employment agency", value: 17 },
    { label: "Gmail", value: 18 },
    { label: "Job fair", value: 19 },
    { label: "Others", value: 20 },
    { label: "Outlook", value: 21 },
    { label: "Passive sourcing", value: 22 },
    { label: "Resume inbox", value: 23 },
  ];

  const getGenderOption = (value, genderOptions) => {
    if (!value) return "";
    const found = genderOptions.find((g) => g.value === value);
    return found ? found : { label: String(value), value };
  };

  const getSourceOption = (value, sourceOptions) => {
    if (!value) return "";
    const found = sourceOptions.find((s) => s.value === value);
    return found ? found : { label: String(value), value };
  };

  const getWorkAuthOption = (value, workAuthOptions) => {
    if (!value) return "";
    const normalized = String(value).trim().toLowerCase();
    const found = workAuthOptions.find(
      (opt) => String(opt.value).trim().toLowerCase() === normalized,
    );
    return found ? found : { label: String(value), value: String(value) };
  };

  const handleClose = () => {
    setFormData(initialFormData);
    onClose();
  };

  useEffect(() => {
    const baseRules = {
      // resume: {
      //   type: "file",
      //   required: true,
      // },
      firstName: {
        type: "text",
        required: true,
      },
      lastName: {
        type: "text",
        required: true,
      },
      jobTitle: {
        type: "text",
        required: true,
      },
      gender: {
        type: "select",
        required: true,
      },
      primaryEmailAddress: {
        type: "text",
        required: true,
      },
    };
    setValidationRules(baseRules);
  }, []);

  useEffect(() => {
    const fetchApplicantDetails = async () => {
      if (edit && applicantId) {
        try {
          setLoading(true);
          const params = {
            fil: JSON.stringify({
              uiid: { type: "NONE", value: applicantId },
            }),
            coll: "Candidate",
            ref: "Resume",
          };

          const response = await getApplicant(params);

          if (response?.data?.data) {
            const applicant = response?.data?.data;
            // console.log("Prefilling data with applicant:", applicant);

            setFormData({
              ...formData,
              firstName: applicant.firstName || "",
              middleName: applicant.middleName || "",
              lastName: applicant.lastName || "",
              // gender: applicant.gender
              //   ? { label: applicant.genderLabel || applicant.gender, value: applicant.gender }
              //   : "",
              gender: getGenderOption(applicant.gender, genderOptions),
              primaryEmailAddress: applicant.email?.primary?.email || "",
              secondaryEmailAddress: applicant.email?.secondary?.email || "",
              primaryMobileNumber: {
                code: applicant.mobile?.primary?.code || "",
                number: applicant.mobile?.primary?.number || "",
              },
              homeMobileNumber: {
                code: applicant.mobile?.secondary?.code || "",
                number: applicant.mobile?.secondary?.number || "",
              },
              personalState: applicant.location?.state?.name
                ? {
                    label: applicant.location?.state.name,
                    value: applicant.location?.state.name,
                  }
                : "",
              personalCity: applicant.location?.city
                ? {
                    label: applicant.location?.city,
                    value: applicant.location?.city,
                  }
                : "",
              zipCode: applicant.location?.zipCode || "",
              years: applicant.exp?.year || "",
              months: applicant.exp?.mon || "",
              jobTitle: applicant.jobTitle || "",
              // sourceOfResume: applicant.source
              //   ? { label: applicant.source, value: applicant.source }
              //   : "",
              sourceOfResume: getSourceOption(applicant.source, sourceOptions),
              // skills: applicant.skills
              //   ? applicant.skills.map((s) => s.name).join(", ")
              //   : "",
              skills: (applicant?.skills || []).map((s) => s.name),
              // workAuthorization: applicant.workAuth
              //   ? { label: applicant.workAuth, value: applicant.workAuth }
              //   : "",
              workAuthorization: getWorkAuthOption(
                applicant.workAuth,
                workAuthOptions,
              ),
              readyToRelocate: applicant.relocation.willingness ? "yes" : "no",
              schoolName: applicant.educationDetails?.[0]?.institute || "",
              degree: applicant.educationDetails?.[0]?.degree || "",
              yearCompleted: applicant.educationDetails?.[0]?.endDate
                ? new Date(applicant.educationDetails[0].endDate)
                : "",
              majorStudy: applicant.educationDetails?.[0]?.major || "",
              minorStudy: applicant.educationDetails?.[0]?.minor || "",
              gpa: applicant.educationDetails?.[0]?.gpa || "",
              country: applicant.educationDetails?.[0]?.location?.country
                ? {
                    label: applicant.educationDetails[0].location.country,
                    value: applicant.educationDetails[0].location.country,
                  }
                : "",
              educationState: applicant.educationDetails?.[0]?.location?.state
                ? {
                    label: applicant.educationDetails[0].location.state,
                    value: applicant.educationDetails[0].location.state,
                  }
                : "",
              educationCity: applicant.educationDetails?.[0]?.location?.city
                ? {
                    label: applicant.educationDetails[0].location.city,
                    value: applicant.educationDetails[0].location.city,
                  }
                : "",
              availability: applicant.available,
              minExperience: applicant?.salaryInfo?.expect.currency || "",
              minExperienceMin: applicant?.salaryInfo?.expect?.amount?.min,
              minExperienceMax: applicant?.salaryInfo?.expect?.amount?.max,
              minExperienceRateType: applicant?.salaryInfo?.expect?.freqType,
              minExperienceJobType:
                applicant?.salaryInfo?.expect?.employmentType,

              // uploadedResume: {
              //   existingFile: applicant.resumes?.[0]?.files?.[0] || null,
              // },
              uploadedResume: {
                id: uuidv4(),
                attachmentName: "",
                attachmentComments: "",
                existingFiles:
                  applicant.resumes?.flatMap((r) => r.files || []) || [],
                chooseFiles: [],
              },
            });
          } else {
            showToast("No applicant found for this ID", "error");
          }
        } catch (error) {
          console.error("Error fetching applicant:", error);
          showToast("Failed to load applicant details", "error");
        } finally {
          setLoading(false);
        }
      }
    };

    fetchApplicantDetails();
  }, [edit, applicantId, isOpen]);

  useEffect(() => {
    if (!parsedData || edit) return;

    const p = parsedData;

    const prefilled = {
      firstName: p.personalDetails?.firstName || "",
      middleName: p.personalDetails?.middleName || "",
      lastName: p.personalDetails?.lastName || "",
      gender: p.personalDetails?.gender
        ? { label: p.personalDetails.gender, value: p.personalDetails.gender }
        : "",
      primaryEmailAddress: p.personalDetails?.email?.primary?.email || "",
      secondaryEmailAddress: p.personalDetails?.email?.secondary?.email || "",
      primaryMobileNumber: {
        code: p.personalDetails?.mobile?.primary?.code || "",
        number: p.personalDetails?.mobile?.primary?.number || "",
      },
      homeMobileNumber: {
        code: p.personalDetails?.mobile?.secondary?.code || "",
        number: p.personalDetails?.mobile?.secondary?.number || "",
      },
      personalState: p.personalDetails?.location?.state
        ? {
            label: p.personalDetails.location.state.name,
            value: p.personalDetails.location.state.name,
          }
        : "",
      personalCity: p.personalDetails?.location?.city
        ? {
            label: p.personalDetails.location.city,
            value: p.personalDetails.location.city,
          }
        : "",
      zipCode: p.personalDetails?.location?.zipCode || "",
      years: p.professionalDetails?.experience?.years || "",
      months: p.professionalDetails?.experience?.months || "",
      jobTitle: p.professionalDetails?.jobTitle || "",
      // skills: p.professionalDetails?.skills?.map(s => s.name).filter(Boolean).join(", ") || "",
      skills:
        p.professionalDetails?.skills?.map((s) => s.name).filter(Boolean) || [],
      workAuthorization: p.professionalDetails?.workAuth
        ? {
            label: p.professionalDetails.workAuth,
            value: p.professionalDetails.workAuth,
          }
        : "",
      availability: p.professionalDetails?.available || "",
      schoolName: p.educationDetails?.[0]?.institute || "",
      degree: p.educationDetails?.[0]?.degree || "",
      yearCompleted: p.educationDetails?.[0]?.endDate
        ? new Date(p.educationDetails[0].endDate.toString())
        : "",
      majorStudy: p.educationDetails?.[0]?.major || "",
      minorStudy: p.educationDetails?.[0]?.minor || "",
      gpa: p.educationDetails?.[0]?.gpa || "",
      country: p.educationDetails?.[0]?.location?.country
        ? {
            label: p.educationDetails[0].location.country,
            value: p.educationDetails[0].location.country,
          }
        : "",
      educationState: p.educationDetails?.[0]?.location?.state
        ? {
            label: p.educationDetails[0].location.state,
            value: p.educationDetails[0].location.state,
          }
        : "",
      educationCity: p.educationDetails?.[0]?.location?.city
        ? {
            label: p.educationDetails[0].location.city,
            value: p.educationDetails[0].location.city,
          }
        : "",
    };

    setFormData((prev) => ({ ...prev, ...prefilled }));
  }, [parsedData, edit]);

  // for selected resume while parsing
  useEffect(() => {
    if (preselectedResume && !edit) {
      setFormData((prev) => ({
        ...prev,
        uploadedResume: {
          ...prev.uploadedResume,
          chooseFiles: [preselectedResume],
        },
      }));
    }
  }, [preselectedResume, edit]);
  return (
    <div className="flex flex-1 overflow-auto">
      <Drawer
        isOpen={isOpen}
        // onClose={onClose}
        onClose={handleClose}
        position="left"
        width="w-[80%]"
        title={edit ? "Edit Applicant" : "Add Applicant"}
      >
        <HeaderStyle title={"Personal Details"} />
        <div className="grid lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 grid-cols-2 gap-x-6 gap-y-8 my-4">
          <FormFieldSet
            title="First Name"
            placeholder="Name"
            value={formData.firstName}
            onChange={(value) => handleChange("firstName", value)}
            error={errors.firstName}
            shadow={true}
            required
          />
          <FormFieldSet
            title="Middle Name"
            placeholder="Name"
            value={formData.middleName}
            onChange={(value) => handleChange("middleName", value)}
            error={errors.middleName}
            shadow={true}
          />
          <FormFieldSet
            title="last Name"
            placeholder="Name"
            value={formData.lastName}
            onChange={(value) => handleChange("lastName", value)}
            error={errors.lastName}
            shadow={true}
            required
          />
          <FormFieldSet
            title="Gender"
            placeholder="Select"
            type="select"
            value={formData.gender}
            options={genderOptions}
            onChange={(value) => handleChange("gender", value)}
            error={errors.gender}
            shadow={true}
            required
          />
          <FormFieldSet
            type="text"
            title="Primary Email Address"
            placeholder="Primary Email Address"
            value={formData.primaryEmailAddress}
            onChange={(value) => handleChange("primaryEmailAddress", value)}
            error={errors.primaryEmailAddress}
            shadow={true}
            required
          />
          <FormFieldSet
            type="text"
            title="Secondary Email Address"
            placeholder="Secondary Email Address"
            value={formData.secondaryEmailAddress}
            onChange={(value) => handleChange("secondaryEmailAddress", value)}
            error={errors.secondaryEmailAddress}
            shadow={true}
          />
          {/* <FormFieldSet
            title="Mobile Number (Primary)"
            placeholder="Primary Mobile Number"
            value={formData.primaryMobileNumber}
            onChange={(value) => handleChange("primaryMobileNumber", value)}
            error={errors.primaryMobileNumber}
            shadow={true}
          /> */}
          <FormFieldSet
            title="Mobile Number (Primary)"
            type="phone"
            placeholder="Primary Mobile Number"
            value={formData.primaryMobileNumber.number}
            code={formData.primaryMobileNumber.code}
            onChange={(fullValue, details) =>
              handleChange("primaryMobileNumber", {
                code: details.countryCode,
                number: details.number,
              })
            }
            shadow
            required
          />
          {/* <FormFieldSet
            title="Mobile Number (Home)"
            placeholder="Home Mobile Number"
            value={formData.homeMobileNumber}
            onChange={(value) => handleChange("homeMobileNumber", value)}
            error={errors.homeMobileNumber}
            shadow={true}
          /> */}
          <FormFieldSet
            title="Mobile Number (Home)"
            type="phone"
            placeholder="Home Mobile Number"
            value={formData.homeMobileNumber.number}
            code={formData.homeMobileNumber.code}
            onChange={(fullValue, details) =>
              handleChange("homeMobileNumber", {
                code: details.countryCode,
                number: details.number,
              })
            }
            shadow
          />
          <FormFieldSet
            type="states"
            title="State"
            placeholder="State"
            value={formData.personalState}
            onChange={(value) => handleChange("personalState", value)}
            error={errors.personalState}
            shadow={true}
            parentValue={{ country: "United States" }}
          />
          <FormFieldSet
            type="cities"
            title="City"
            placeholder="City"
            value={formData.personalCity}
            onChange={(value) => handleChange("personalCity", value)}
            error={errors.personalCity}
            shadow={true}
            parentValue={{
              // country: formData.country?.value,
              country: "United States",
              state: formData.personalState?.value,
            }}
            disabled={!formData.personalState}
          />
          <FormFieldSet
            title="Zip Code"
            placeholder="Zip Code"
            value={formData.zipCode}
            onChange={(value) => handleChange("zipCode", value)}
            error={errors.zipCode}
            shadow={true}
          />
        </div>
        <div className="col-span-2"></div>
        <HeaderStyle title={"Professional Details"} />
        <div className="grid  grid-cols-1 lg:grid-cols-2 gap-x-6 gap-y-8 mt-4 ">
          <FormFieldSet
            type="file"
            placeholder="upload"
            title="Upload Resume"
            value={formData.uploadedResume}
            // onChange={(value) => handleChange("uploadedResume", value)}
            onChange={(value) => {
              // console.log("value",value)
              const file = value?.chooseFiles?.[0];
              if (file) {
                const allowedTypes = [
                  "application/pdf",
                  "application/msword",
                  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                ];
                if (!allowedTypes.includes(file.type)) {
                  showToast(
                    "Only PDF, DOC, or DOCX files are allowed!",
                    "error",
                  );
                  return;
                }
              }
              handleChange("uploadedResume", value);
            }}
            error={errors.uploadedResume}
            multiple
            shadow={true}
            required
          />
          {/* Existing uploaded files (editable list) */}
          {edit && formData.uploadedResume?.existingFiles?.length > 0 && (
            <div className="mt-3 p-3 rounded-md bg-gray-50 border">
              <p className="font-medium text-sm mb-2">
                Existing Uploaded Files:
              </p>
              <ul className="space-y-2">
                {formData.uploadedResume.existingFiles.map((file, index) => {
                  const fileName =
                    file.originalname || file.name || `File ${index + 1}`;
                  const fileUrl = file.url || file.path || file.s3Url || null;

                  return (
                    <li
                      key={index}
                      className="flex items-center justify-between text-sm text-gray-700 bg-white px-3 py-1 rounded shadow-sm"
                    >
                      <div className="flex items-center gap-2 truncate">
                        <a
                          href={fileUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-info-600 hover:underline truncate"
                        >
                          {fileName}
                        </a>
                      </div>
                      <button
                        type="button"
                        className="text-red-500 hover:text-red-700 text-xs"
                        onClick={() => {
                          // 🗑 remove file locally
                          const updatedFiles =
                            formData.uploadedResume.existingFiles.filter(
                              (_, i) => i !== index,
                            );
                          handleChange("uploadedResume", {
                            ...formData.uploadedResume,
                            existingFiles: updatedFiles,
                          });
                        }}
                      >
                        Remove
                      </button>
                    </li>
                  );
                })}
              </ul>
            </div>
          )}
          {formData?.uploadedResume?.chooseFiles?.length > 0 && (
            <div className="mt-3 p-3 rounded-md bg-gray-50 border">
              <p className="font-medium text-sm mb-2">
                Existing Uploaded Files:
              </p>
              <ul className="space-y-2">
                {formData.uploadedResume.chooseFiles.map((file, index) => {
                  const fileName =
                    file.originalname || file.name || `File ${index + 1}`;
                  const fileUrl = file.url || file.path || file.s3Url || null;

                  return (
                    <li
                      key={index}
                      className="flex items-center justify-between text-sm text-gray-700 bg-white px-3 py-1 rounded shadow-sm"
                    >
                      <div className="flex items-center gap-2 truncate">
                        <a
                          href={fileUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-blue-600 hover:underline truncate"
                        >
                          {fileName}
                        </a>
                      </div>
                      <button
                        type="button"
                        className="text-red-500 hover:text-red-700 text-xs"
                        onClick={() => {
                          // 🗑 remove file locally
                          const updatedFiles =
                            formData.uploadedResume.chooseFiles.filter(
                              (_, i) => i !== index,
                            );
                          handleChange("uploadedResume", {
                            ...formData.uploadedResume,
                            chooseFiles: updatedFiles,
                          });
                        }}
                      >
                        Remove
                      </button>
                    </li>
                  );
                })}
              </ul>
            </div>
          )}

          <div className="grid grid-cols-2 gap-x-4">
            <FormFieldSet
              title={"Experience"}
              placeholder="Years"
              value={formData.years}
              onChange={(value) => handleChange("years", value)}
              error={errors.experience}
              shadow={true}
            />
            <FormFieldSet
              title={""}
              placeholder="Months"
              value={formData.months}
              onChange={(value) => handleChange("months", value)}
              error={errors.years}
              shadow={true}
            />
          </div>
          <FormFieldSet
            title={"Job Title"}
            placeholder="Job Title"
            value={formData.jobTitle}
            onChange={(value) => handleChange("jobTitle", value)}
            error={errors.jobTitle}
            shadow={true}
            required
          />
          <FormFieldSet
            type="select"
            title={"Source Of Resume"}
            placeholder="Source Of Resume"
            value={formData.sourceOfResume}
            options={sourceOptions}
            onChange={(value) => handleChange("sourceOfResume", value)}
            error={errors.sourceOfResume}
            shadow={true}
            showSearch
          />
          <div className="grid  2xl:grid-cols-5 md:grid-cols-3  gap-x-4">
            <FormFieldSet
              type="select"
              title={"Pay Rate / Salary"}
              placeholder="Select"
              value={formData.minExperience}
              onChange={(value) => handleChange("minExperience", value)}
              options={[
                { label: "USD", value: 1 },
                { label: "INR", value: 2 },
                { label: "CAN", value: 3 },
              ]}
              error={errors.minExperience}
              shadow={true}
            />
            <FormFieldSet
              title={""}
              placeholder="min"
              shadow={true}
              value={formData.minExperienceMin}
              onChange={(value) => handleChange("minExperienceMin", value)}
            />
            <FormFieldSet
              title={""}
              placeholder="max"
              shadow={true}
              value={formData.minExperienceMax}
              onChange={(value) => handleChange("minExperienceMax", value)}
            />
            <FormFieldSet
              type="select"
              placeholder="Select"
              title={""}
              value={formData.minExperienceRateType}
              onChange={(value) => handleChange("minExperienceRateType", value)}
              options={[
                { label: "Hourly", value: "hourly" },
                { label: "Daily", value: "daily" },
                { label: "Weekly", value: "weekly" },
                { label: "Bi-Weekly", value: "bi-weekly" },
                { label: "Monthly", value: "monthly" },
                { label: "Yearly", value: "yearly" },
              ]}
              shadow={true}
              showSearch
            />
            <FormFieldSet
              type="select"
              placeholder="Select"
              title={""}
              value={formData.minExperienceJobType}
              onChange={(value) => handleChange("minExperienceJobType", value)}
              options={[
                { label: "1099", value: 1 },
                { label: "C2C", value: 2 },
                { label: "C2C", value: 3 },
                { label: "Full Time", value: 4 },
                { label: "In-cop", value: 5 },
                { label: "Intern", value: 6 },
                { label: "Other", value: 7 },
                { label: "Part Time", value: 8 },
                { label: "W-2", value: 9 },
              ]}
              shadow={true}
              showSearch
            />
          </div>
          <FormFieldSet
            title={"Availability"}
            placeholder="Availability"
            value={formData.availability}
            onChange={(value) => handleChange("availability", value)}
            error={errors.availability}
            shadow={true}
          />
          <FormFieldSet
            type="tags"
            title={"Skills"}
            // placeholder="Skills"
            placeholder="Please type and press enter"
            value={formData.skills}
            onChange={(value) => {
              handleChange("skills", value);
              console.log("Skills value:", value);
            }}
            error={errors.skills}
            shadow={true}
            maxCount={50}
            validate={(tag) => {
              if (!/^[a-zA-Z0-9\s.+#-]*$/.test(tag))
                return "Only letters, numbers, spaces, ., +, # and - are allowed.";

              if (/^\d+$/.test(tag)) return "Skill cannot be only numbers.";

              if (!/[a-zA-Z]/.test(tag))
                return "Skill must contain at least one letter.";

              if (/\d{3,}/.test(tag))
                return "Numbers cannot appear more than 2 times consecutively.";

              if (tag.length < 2) return "Skill must be at least 2 characters.";

              if (tag.length > 50) return "Skill must be under 50 characters.";

              if (
                formData.skills?.some(
                  (s) => s.toLowerCase() === tag.toLowerCase(),
                )
              )
                return "Skill already added.";

              return true;
            }}
          />
          <FormFieldSet
            type="select"
            placeholder="Work Authorization"
            title={"Work Authorization"}
            value={formData.workAuthorization}
            options={workAuthOptions}
            onChange={(value) => handleChange("workAuthorization", value)}
            error={errors.workAuthorization}
            shadow={true}
            showSearch
          />
          <FormFieldSet
            type="radio"
            size="md"
            title="Ready To Relocate"
            placeholder="Enter Zip Code"
            options={[
              { label: "Yes", value: "yes" },
              { label: "No", value: "no" },
            ]}
            value={formData.readyToRelocate}
            onChange={(event) =>
              handleChange("readyToRelocate", event.target.value)
            }
            error={errors.readyToRelocate}
          />
        </div>
        <HeaderStyle title={"Education Details"} />
        <div className="grid grid-cols-2 xl:grid-cols-4 2xl:grid-cols-5 lg:grid-cols-3 gap-x-6 gap-y-8 mt-4 ">
          <FormFieldSet
            title={"School Name"}
            placeholder="Enter the Name"
            value={formData.schoolName}
            onChange={(value) => handleChange("schoolName", value)}
            error={errors.schoolName}
            shadow={true}
          />
          <FormFieldSet
            title={"Degree"}
            placeholder="Degree"
            value={formData.degree}
            onChange={(value) => handleChange("degree", value)}
            error={errors.degree}
            shadow={true}
          />
          <FormFieldSet
            type="datepicker"
            title={"Year Completed"}
            placeholder="MM/DD/YYYY"
            value={formData.yearCompleted}
            onChange={(value) => handleChange("yearCompleted", value)}
            error={errors.yearCompleted}
            shadow={true}
          />
          <FormFieldSet
            title={"Major Study"}
            placeholder="Major Study"
            value={formData.majorStudy}
            onChange={(value) => handleChange("majorStudy", value)}
            error={errors.majorStudy}
            shadow={true}
          />
          <FormFieldSet
            title={"Minor Study"}
            placeholder="Minor Study"
            value={formData.minorStudy}
            onChange={(value) => handleChange("minorStudy", value)}
            error={errors.minorStudy}
            shadow={true}
          />
          <FormFieldSet
            title={"GPA"}
            placeholder="GPA"
            value={formData.gpa}
            onChange={(value) => handleChange("gpa", value)}
            error={errors.gpa}
            shadow={true}
          />
          <FormFieldSet
            // type="select"
            type="countriesUsAndCanada"
            placeholder="Select"
            title={"Country"}
            value={formData.country}
            onChange={(value) => handleChange("country", value)}
            error={errors.country}
            shadow={true}
          />
          <FormFieldSet
            // type="select"
            showSearch
            type="states"
            placeholder="Select"
            title={"State"}
            value={formData.educationState}
            onChange={(value) => handleChange("educationState", value)}
            parentValue={{ country: formData?.country?.value }}
            disabled={!formData.country}
            error={errors.educationState}
            shadow={true}
          />
          <FormFieldSet
            type="cities"
            showSearch
            title={"City"}
            placeholder="City"
            value={formData.educationCity}
            onChange={(value) => handleChange("educationCity", value)}
            error={errors.educationCity}
            parentValue={{
              country: formData.country?.value,
              state: formData.educationState?.value,
            }}
            disabled={!formData.educationState}
            shadow={true}
          />
        </div>
        <div className="flex my-20 gap-3 justify-end">
          <Button
            title="Cancel"
            variant="outlined"
            // onClick={onClose}
            onClick={handleClose}
          />
          <Button title="Submit Application" onClick={handleSubmit} />
        </div>
        <Backdrop isOpen={loading}>
          <LogoLoader />
        </Backdrop>
      </Drawer>
    </div>
  );
};

export default AddApplicantModal;
